/* walleu-gallery — chip filtering + shop-the-look modal.
   The grid is fully server-rendered; clicking a chip only toggles [hidden]
   on non-matching items (the CSS columns reflow by themselves), and tapping
   a photo marked [data-modal] opens the section's native <dialog> populated
   from the item's data attributes — the image is the grid's own <img>
   cloned with a bigger `sizes`, so the modal costs zero extra requests.
   Photos with a custom link (and no product) keep plain link behavior, and
   everything degrades to regular links without JS. In the theme editor,
   selecting a photo block resets the filter so the merchant always sees
   the block they clicked. */
(() => {
  class WalleuGallery extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('.walleu-gallery__modal');

      this.addEventListener('click', (event) => {
        const chip = event.target.closest('.walleu-gallery__chip');

        if (chip) {
          this.filter(chip.dataset.filter);
          return;
        }

        const item = event.target.closest('.walleu-gallery__item[data-modal]');

        if (item && this.modal) {
          event.preventDefault();
          this.openModal(item);
        }
      });

      if (this.modal) {
        this.modal.querySelector('.walleu-gallery__modal-close').addEventListener('click', () => this.modal.close());

        // A click on the backdrop targets the <dialog> itself
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) {
            this.modal.close();
          }
        });

        this.modal.addEventListener('close', () => {
          document.documentElement.style.removeProperty('overflow');
        });
      }

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target)) {
            this.filter('');
          }
        });
      }
    }

    filter(category) {
      this.querySelectorAll('.walleu-gallery__chip').forEach((chip) => {
        chip.setAttribute('aria-pressed', String(chip.dataset.filter === category));
      });

      this.querySelectorAll('.walleu-gallery__item').forEach((item) => {
        item.hidden = category !== '' && item.dataset.category !== category;
      });
    }

    openModal(item) {
      const media = this.modal.querySelector('.walleu-gallery__modal-media');
      media.innerHTML = '';

      const image = item.querySelector('img');

      if (image) {
        const clone = image.cloneNode();
        clone.loading = 'eager';
        clone.sizes = '(max-width: 699px) 100vw, 28rem';
        media.appendChild(clone);
      }

      this.modal.querySelector('.walleu-gallery__modal-category').textContent = item.dataset.categoryLabel || '';
      this.modal.querySelector('.walleu-gallery__modal-title').textContent = item.dataset.title || '';
      this.modal.querySelector('.walleu-gallery__modal-price').textContent = item.dataset.price || '';

      const cta = this.modal.querySelector('.walleu-gallery__modal-cta');
      cta.hidden = !item.dataset.url;
      cta.href = item.dataset.url || '#';

      document.documentElement.style.overflow = 'hidden';
      this.modal.showModal();
    }
  }

  if (!window.customElements.get('walleu-gallery')) {
    window.customElements.define('walleu-gallery', WalleuGallery);
  }
})();
